import React, { useRef, useState } from "react";
import { css } from "@emotion/core";
import { Desktop, Tablet } from "../constants/responsive";
import { FormattedHTMLMessage, useIntl } from "gatsby-plugin-intl";
import Container from "../components/Container";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import Blank from "../components/Blank";
import { useUpdateEffect } from "react-use";
import Upload from "../components/Upload";
import Axios from "axios";
import InfoSubmitted from "../components/CareerInfoSubmitted";
import CareerInfoUploading from "../components/CareerInfoUploading";
import JobRow from "../components/CareerJobRow";

const JobPage = ({ pageContext, companyName }) => {
  const intl = useIntl();
  const [consent, setConsent] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const [resumeFilePath, setResumeFilePath] = useState("");
  const [letterFilePath, setLetterFilePath] = useState("");
  const [resumeUploading, setResumeUploading] = useState(false);
  const [letterUploading, setLetterUploading] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [applicantInfoSubmit, setApplicantInfoSubmit] = useState({});

  const submittedRef = useRef();
  // 信息提交成功，需要将页面滚动条回归顶部
  useUpdateEffect(() => {
    if (submitSuccess) {
      window.scrollTo({
        top: submittedRef.current.offsetTop,
        left: 0,
      });
    }
  }, [submitSuccess]);
  useUpdateEffect(() => {
    if (!letterUploading && !resumeUploading) {
      // 如果文件上传完成，提交求职者所有信息
      // 所有数据检验均通过，则提交求职信息
      applicantInfoSubmit["resume"] = resumeFilePath;
      applicantInfoSubmit["coverLetter"] = letterFilePath;
      if (flag) {
        // 两个文件地址取不到，猜测是set延迟
        Axios.post(
          {
            live: "https://smarthk.aqumon.com/api/v4/recruit/notice",
            test: "https://test-smarthk.aqumon.com/api/v4/recruit/notice",
          }[process.env.GATSBY_ENV],
          applicantInfoSubmit
        ).then((res) => {
          if (!res.data.status.ecode) {
            // 验证码发送成功
            setShowLoading(false);
            setSubmitSuccess(true);
          } else {
            // 发送失败
            console.log(res);
          }
        });
      }
    }
  }, [letterUploading, resumeUploading, flag]);

  const errMsg = {
    uploadFile: {
      en: "Please upload files",
      "zh-cn": "请上传文件",
      "zh-hk": "請上傳文件",
    }[intl.locale],
    requiredMsg: {
      en: "Required fields cannot be empty",
      "zh-cn": "必填项不能为空",
      "zh-hk": "必填項不能爲空",
    }[intl.locale],
    formatErrMsg: {
      en: "Format error",
      "zh-cn": "格式错误",
      "zh-hk": "格式錯誤",
    }[intl.locale],
    phoneFormatErrMsg: {
      en: "Format error(Reminder:please do not add space in between or add any symbols)",
      "zh-cn": "格式错误(提醒:请不要在中间添加空格或添加任何符号)",
      "zh-hk": "格式錯誤(提醒:請不要在中間添加空格或添加任何符號)",
    }[intl.locale],
    pleaseChoose: {
      en: "please choose",
      "zh-cn": "请选择",
      "zh-hk": "請選擇",
    }[intl.locale],
  };

  return (
    <Layout>
      <SEO
        title={intl.formatMessage({ id: "career.title" })}
        description={intl.formatMessage({ id: "career.description" })}
        keywords={intl.formatMessage({ id: "career.keywords" })}
      />
      {/* 页面内容最顶端的隐藏标签。用于提交信息成功后滚动条回归顶部位置 */}
      <div ref={submittedRef}></div>
      <CareerInfoUploading
        showUploading={showLoading}
        setShowUploading={setShowLoading}
      />
      {/* 求职信息填写页面 */}
      <div
        css={css`
          display: ${submitSuccess ? "none" : "block"};
        `}
      >
        <Blank height={[50, 100, 100]} />
        {/* 职位、职责、任职要求等详情 */}
        <Container
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <h1
            css={css`
              color: #000000;

              ${Tablet} {
                text-align: center;
                font-size: 36px;
                font-weight: 500;
                line-height: 1.33;
                margin-bottom: 40px;
              }
              ${Desktop} {
                font-size: 36px;
                font-weight: bold;
                line-height: 0.92;
                margin-bottom: 30px;
              }
            `}
          >
            {intl.formatMessage({
              id: `career.job.jobsInfo.${pageContext.name}.title`,
            })}
          </h1>
          <div
            css={css`
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              ${Tablet} {
                justify-content: center;
              }
              h4 {
                color: #000000;
                margin: 0;
                font-size: 16px;
                font-weight: normal;
                line-height: 24px;
                ${Tablet} {
                  font-size: 18px;
                  font-weight: 500;
                  line-height: 1.11;
                }
                ${Desktop} {
                  font-size: 18px;
                  font-weight: 500;
                  line-height: 1.33;
                }
              }
            `}
          >
            <h4
              css={css`
                width: 100%;
                ${Tablet} {
                  width: auto;
                }
              `}
            >
              {intl.formatMessage({
                id: `career.job.jobsInfo.${pageContext.name}.department`,
              })}
            </h4>
            <Blank width={[0, 70, 80]} />
            <h4>
              {intl.formatMessage({
                id: `career.job.jobsInfo.${pageContext.name}.location`,
              })}
            </h4>
            <Blank width={[16, 70, 80]} />
            <h4>
              {intl.formatMessage({
                id: `career.job.jobsInfo.${pageContext.name}.type`,
              })}
            </h4>
          </div>
          <Blank height={[100, 88, 100]} />
          {intl.formatMessage({
            id: `career.job.jobsInfo.${pageContext.name}.job-desc.title`,
          }) !== `career.job.jobsInfo.${pageContext.name}.job-desc.title` ? (
            <>
              {/* Job Description */}
              <section
                css={css`
                  ${Tablet} {
                  }
                  ${Desktop} {
                  }
                `}
              >
                <h4
                  css={css`
                    margin: 0;
                    color: #000000;
                    font-size: 24px;
                    font-weight: 500;
                    line-height: 1.38;
                    margin-bottom: 20px;
                    ${Tablet} {
                      font-size: 24px;
                      font-weight: 500;
                      line-height: 1.38;
                    }
                    ${Desktop} {
                      font-size: 24px;
                      font-weight: 500;
                      line-height: 1.38;
                      margin-bottom: 20px;
                    }
                  `}
                >
                  {intl.formatMessage({
                    id: `career.job.jobsInfo.${pageContext.name}.job-desc.title`,
                  })}
                </h4>
                <div
                  css={css`
                    padding-left: 20px;
                    p {
                      margin: 0;
                      padding: 0;
                      color: #000000;
                      font-size: 16px;
                      font-weight: normal;
                      line-height: 1.56;
                      ${Tablet} {
                        font-size: 18px;
                        font-weight: normal;
                        line-height: 1.39;
                      }
                      ${Desktop} {
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 1.38;
                      }
                    }
                  `}
                >
                  <FormattedHTMLMessage
                    id={`career.job.jobsInfo.${pageContext.name}.job-desc.content`}
                  />
                </div>
              </section>
              <Blank height={[50, 50, 40]} />
            </>
          ) : null}
          {/* Job Responsibilities */}
          <section
            css={css`
              ${Tablet} {
              }
              ${Desktop} {
              }
            `}
          >
            <h4
              css={css`
                margin: 0;
                color: #000000;
                font-size: 24px;
                font-weight: 500;
                line-height: 1.38;
                margin-bottom: 20px;
                ${Tablet} {
                  font-size: 24px;
                  font-weight: 500;
                  line-height: 1.38;
                }
                ${Desktop} {
                  font-size: 24px;
                  font-weight: 500;
                  line-height: 1.38;
                  margin-bottom: 20px;
                }
              `}
            >
              {intl.formatMessage({
                id: `career.job.jobsInfo.${pageContext.name}.responsibilities.title`,
              })}
            </h4>
            <ul
              css={css`
                li {
                  margin: 0;
                  padding: 0;
                  color: #000000;
                  font-size: 16px;
                  font-weight: normal;
                  line-height: 1.56;
                  ${Tablet} {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 1.39;
                  }
                  ${Desktop} {
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 1.38;
                  }
                }
              `}
            >
              <FormattedHTMLMessage
                id={`career.job.jobsInfo.${pageContext.name}.responsibilities.content`}
              />
            </ul>
          </section>
          <Blank height={[50, 50, 40]} />
          {/* Qualifications */}
          <section
            css={css`
              ${Tablet} {
              }
              ${Desktop} {
              }
            `}
          >
            <h4
              css={css`
                margin: 0;
                color: #000000;
                font-size: 24px;
                font-weight: 500;
                line-height: 1.38;
                margin-bottom: 20px;
                ${Tablet} {
                  font-size: 24px;
                  font-weight: 500;
                  line-height: 1.38;
                }
                ${Desktop} {
                  font-size: 24px;
                  font-weight: 500;
                  line-height: 1.38;
                  margin-bottom: 20px;
                }
              `}
            >
              {intl.formatMessage({
                id: `career.job.jobsInfo.${pageContext.name}.qualifications.title`,
              })}
            </h4>
            <ul
              css={css`
                li {
                  margin: 0;
                  padding: 0;
                  color: #000000;
                  font-size: 16px;
                  font-weight: normal;
                  line-height: 1.56;
                  ${Tablet} {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 1.39;
                  }
                  ${Desktop} {
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 1.38;
                  }
                }
              `}
            >
              <FormattedHTMLMessage
                id={`career.job.jobsInfo.${pageContext.name}.qualifications.content`}
              />
            </ul>
          </section>
          <Blank height={[50, 50, 40]} />
          {/* Personality Fit */}
          <section
            css={css`
              ${Tablet} {
              }
              ${Desktop} {
              }
            `}
          >
            <h4
              css={css`
                margin: 0;
                color: #000000;
                font-size: 24px;
                font-weight: 500;
                line-height: 1.38;
                margin-bottom: 20px;
                ${Tablet} {
                  font-size: 24px;
                  font-weight: 500;
                  line-height: 1.38;
                }
                ${Desktop} {
                  font-size: 24px;
                  font-weight: 500;
                  line-height: 1.38;
                  margin-bottom: 20px;
                }
              `}
            >
              {intl.formatMessage({
                id: `career.job.jobsInfo.${pageContext.name}.personality-fit.title`,
              })}
            </h4>
            <ul
              css={css`
                li {
                  margin: 0;
                  padding: 0;
                  color: #000000;
                  font-size: 16px;
                  font-weight: normal;
                  line-height: 1.56;
                  ${Tablet} {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 1.39;
                  }
                  ${Desktop} {
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 1.38;
                  }
                }
              `}
            >
              <FormattedHTMLMessage
                id={`career.job.jobsInfo.${pageContext.name}.personality-fit.content`}
              />
            </ul>
          </section>
          {/* Publish Time */}
          {intl.formatMessage({
            id: `career.job.jobsInfo.${pageContext.name}.publishTime`,
          }) !== `career.job.jobsInfo.${pageContext.name}.publishTime` ? (
            <div
              css={css`
                  text-align: right;
                  margin-top: 48px;
                `}
            >
              <div>{pageContext.companyName}</div>
              <div>
                {intl.formatMessage({
                  id: `career.job.jobsInfo.${pageContext.name}.publishTime`,
                })}
              </div>
            </div>
          ) : null}
        </Container>
        <Blank height={[100, 168, 163]} />
        <Container
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            ${Tablet} {
            }
          `}
        >
          {/* title */}
          <h2
            css={css`
              text-align: center;
              font-size: 24px;
              font-weight: 500;
              line-height: 1.33;
              margin-bottom: 20px;
              ${Tablet} {
                margin-bottom: 30px;
                font-size: 36px;
                font-weight: 500;
                line-height: 1.33;
              }
              ${Desktop} {
                font-size: 36px;
                font-weight: bold;
                line-height: 0.92;
              }
            `}
          >
            {intl.formatMessage({ id: `career.job.form.title` })}
          </h2>
          <div
            css={css`
              width: 100%;
              max-width: 708px;
              ${Desktop} {
                max-width: 742px;
              }
            `}
          >
            {/* 表单 */}
            <JobRow type="text" name="first-name" required />
            <JobRow type="text" name="last-name" required />
            <JobRow type="text" name="email" required />
            <JobRow type="phone" name="phone" required />
            <JobRow
              type="select"
              name="location"
              required
              options={["hk", "sz", "cn", "other"]}
            />
            <Upload
              required
              name="resume"
              setReturnFilePath={setResumeFilePath}
              setUploadingFlag={setResumeUploading}
            ></Upload>
            <Blank height={[20, 50, 40]} />
            <Upload
              name="letter"
              setReturnFilePath={setLetterFilePath}
              setUploadingFlag={setLetterUploading}
            ></Upload>
            <Blank height={[50, 100, 100]} />
            <JobRow
              type="select"
              name="qualifications"
              wrap
              required
              options={["AD", "BD", "MD", "DD"]}
            />
            <JobRow type="text" name="educational-institution" wrap required />
            <JobRow type="text" name="website" wrap />
            <JobRow type="text" name="linkedIn" wrap />
            <JobRow type="textarea" name="about-you" wrap required />
            <JobRow
              type="select"
              name="hear-from"
              wrap
              required
              options={[
                "online",
                "aqm-website",
                "social-media",
                "rec-by-others",
                "print",
                "other",
              ]}
            />

            <Blank height={[30, 80, 30]} />
            {/* 同意发送 */}
            <div
              css={css`
                display: flex;
                align-items: flex-start;
                ${Tablet} {
                }
                ${Desktop} {
                }
              `}
            >
              {/* 勾选圆圈 */}
              <div
                onClick={() => {
                  setConsent(!consent);
                }}
                css={css`
                  flex-shrink: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50%;
                  border: solid 1px #dcdcdc;
                  width: 15px;
                  height: 15px;
                  ${Tablet} {
                    width: 20px;
                    height: 20px;
                  }
                  ${Desktop} {
                    width: 17px;
                    height: 17px;
                  }
                `}
              >
                <div
                  css={css`
                    border-radius: 50%;
                    border: solid 2px #ffffff;
                    width: 100%;
                    height: 100%;
                    background-color: ${consent ? "#ee2f79" : "#ffffff"};
                  `}
                ></div>
              </div>
              {/* 同意发送-text */}
              <p
                css={css`
                  font-size: 10px;
                  font-weight: normal;
                  line-height: 1.4;
                  margin-left: 10px;
                  ${Tablet} {
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 1.29;
                  }
                  ${Desktop} {
                    font-size: 12px;
                    font-weight: normal;
                    line-height: normal;
                  }
                `}
              >
                {intl.formatMessage({ id: `career.job.form.consent` })}
              </p>
            </div>
          </div>
          {/* button */}
          <div
            onClick={() => {
              var tempFlag = true;
              var applicantInfo = {};
              var nameMap = {
                letter: "coverLetter",
                qualifications: "degree",
                email: "email",
                "educational-institution": "latestEducationExperience",
                linkedIn: "linkedIn",
                location: "location",
                phone: "phone",
                resume: "resume",
                "about-you": "selfIntroduction",
                "hear-from": "way",
                website: "website",
              };

              applicantInfo["job"] = intl.formatMessage({
                id: `career.job.jobsInfo.${pageContext.name}.title`,
              });

              // 简历文件不允许为空
              // 拖拽上传的文件实际没有赋值到input中，只是样式改变。所以统一通过判断filename来判断简历文件是否上传
              var filename = document.querySelector(".resume-uploadFileName");
              if (!filename || !filename.innerText) {
                tempFlag = false;
                var errMsgSpans = document.querySelectorAll(".resume-errMsg");
                errMsgSpans[0].innerText = errMsg["uploadFile"];
                errMsgSpans[1].innerText = errMsg["uploadFile"];
              }
              // 文本框-格式检验
              var inputs = document.querySelectorAll("input");
              var applicantName = "";
              [...inputs].map((input) => {
                if (input.className.indexOf("text-") !== -1) {
                  if (input.className.indexOf("text-required") !== -1) {
                    // 必填字段
                    // 判断字段不能为空或空字符串
                    var tip = input.nextSibling;
                    if (!input.value || input.value.match(/^[ ]*$/)) {
                      tip.innerHTML = errMsg["requiredMsg"];
                      tempFlag = false;
                    } else {
                      tip.innerHTML = "";
                      // 【名字字段】需要进行拼接后再传送
                      if (input.name === "first-name") {
                        applicantName = input.value;
                        return;
                      }
                      if (input.name === "last-name") {
                        applicantName =
                          intl.locale === "en"
                            ? applicantName + input.value
                            : input.value + applicantName;
                        applicantInfo["name"] = applicantName;
                        return;
                      }
                      // 【手机号码】不做格式校验，仅拼接区号前缀后提交
                      if (input.name === "phone") {
                        var prefixSelect = document.querySelector(
                          'select[name="phone-prefix"]'
                        );
                        var phonePrefix = prefixSelect
                          ? prefixSelect.value
                          : "";
                        applicantInfo["phone"] = phonePrefix + input.value;
                        return;
                      }
                      // 【邮箱】格式校验
                      if (input.name === "email") {
                        if (
                          !/^[A-Z0-9._%+-]{1,30}@[A-Z0-9.-]{1,50}\.[A-Z]{2,10}$/i.test(
                            input.value
                          )
                        ) {
                          tip.innerHTML = errMsg["formatErrMsg"];
                          tempFlag = false;
                        }
                      }
                      // 其他必填字段 直接赋值
                      applicantInfo[nameMap[input.name]] = input.value;
                    }
                  } else {
                    // 非必填字段
                    if (input.name === "hear-from-other") return;
                    applicantInfo[nameMap[input.name]] = input.value
                      ? input.value
                      : "";
                  }
                }
              });

              var textareas = document.querySelectorAll("textarea");
              [...textareas].map((textarea) => {
                if (textarea.className.indexOf("textarea-required") !== -1) {
                  var tip = textarea.nextSibling;
                  if (!textarea.value || textarea.value.match(/^[ ]*$/)) {
                    tip.innerHTML = errMsg["requiredMsg"];
                    tempFlag = false;
                  } else {
                    tip.innerHTML = "";
                    applicantInfo[nameMap[textarea.name]] = textarea.value;
                  }
                }
              });

              // 下拉框
              var selects = document.querySelectorAll("select");
              [...selects].map((select) => {
                // 手机号区号前缀不参与通用下拉校验
                if (select.name === "phone-prefix") return;
                var tip = select.parentElement.parentElement.lastChild;
                // 不能不选择
                if (!select.value) {
                  tip.innerHTML = errMsg["pleaseChoose"];
                  tempFlag = false;
                } else if (
                  select.name === "hear-from" &&
                  select.value === "other"
                ) {
                  let input = document.querySelector("#hear-from-other");
                  if (!input.value) {
                    tip.innerHTML = errMsg["requiredMsg"];
                    tempFlag = false;
                  } else {
                    tip.innerHTML = "";
                    applicantInfo["way"] = input.value;
                  }
                } else {
                  tip.innerHTML = "";
                  // 获取select选中的值
                  applicantInfo[nameMap[select.name]] =
                    select.options[select.selectedIndex].text;
                }
              });

              if (tempFlag) {
                setShowLoading(true);
                setApplicantInfoSubmit(applicantInfo);
                setFlag(true);
              }
            }}
            css={css`
              cursor: pointer;
              margin-top: 20px;
              width: 177px;
              height: 35px;
              border-radius: 41px;
              pointer-events: ${consent ? "auto" : "none"};
              background-color: ${consent ? "#EE2F79" : "#b3b3b3"};

              font-size: 14px;
              font-weight: bold;
              line-height: 35px;
              text-align: center;
              color: #ffffff;
            `}
          >
            {intl.formatMessage({ id: `career.job.form.submit-application` })}
          </div>
        </Container>
        <Blank height={[100, 100, 100]} />
      </div>
      {/* 求职信息成功提交提示页面 */}
      <InfoSubmitted
        css={css`
          display: ${submitSuccess ? "flex" : "none"};
        `}
      />
    </Layout>
  );
};

export default JobPage;
